import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useListsStore } from '@shared/model'

import { useTasksKanbanStore } from './store'

interface TaskResponsibleTeamReturn {
  refTeamLabel: ComputedRef<string>
}

export const useTaskResponsibleTeam = (): TaskResponsibleTeamReturn => {
  const tasksKanbanStore = useTasksKanbanStore()
  const listsStore = useListsStore()

  const refTeamLabel = computed<string>(() => {
    const team = tasksKanbanStore.getTeam
    if (!team) return ''

    return listsStore.getLists?.tasks_kanban?.lists?.team?.[team] ?? team
  })

  return {
    refTeamLabel,
  }
}